const HideModal = (id) => {
  var modal = document.getElementsByClassName("close")[id];
  modal.click();
};

export default HideModal;


